import React from 'react';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { Button } from 'antd';
import dayjs from 'dayjs';
import { ExportOutlined } from '@ant-design/icons';
import { IFinancialMatchingReportRes } from '@/interfaces/report';
import { formatDate } from '@/utils/dataUtils';

interface IProps {
  data: IFinancialMatchingReportRes[];
  startDate: string;
  endDate: string;
}

const ExcelExport = ({ data }: IProps) => {
  const handleExport = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('FinancialMatchingReport');

    // Define header row
    const headers = [
      '#',
      'CODE',
      'BU',
      'Kemin OrderNo',
      'Kemin InvoicedNo',
      'Kemin LineAmt',
      'Pioneer OrderNo',
      'Pioneer InvoicedNo',
      'Pioneer LineAmt',
      'DIFF',
      'วันที่สั่งซื้อ',
      'รหัสลูกค้า',
      'ลูกค้า',
    ];

    worksheet.getRow(1).values = headers;

    worksheet.getRow(1).eachCell(cell => {
      cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'c6251b' },
      };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
    });

    data.forEach((item, idx) => {
      worksheet.addRow([
        idx + 1,
        item.orderCode,
        item.businessUnitName,
        item.keminOrderNo,
        item.keminInvoiceNo,
        item.keminLineAmount,
        item.orderNo,
        item.invoiceNo,
        item.lineAmount,
        item.diff,
        (item.orderCreateDate && formatDate(item.orderCreateDate)) || '-',
        item.customerCode,
        item.customerName,
      ]);
    });

    // Auto width for columns
    worksheet.columns = headers.map((header, index) => ({
      header,
      key: `col${index}`,
      width: Math.max(header.length, 20) + 2, // Add padding
    }));

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(
      blob,
      `financial-matching-report-${dayjs().format('YYYY-MM-DD')}.xlsx`,
    );
  };

  return (
    <div>
      <Button type="primary" ghost onClick={handleExport}>
        <ExportOutlined /> Export to Excel
      </Button>
    </div>
  );
};

export default ExcelExport;
